import { PartialEnvVarMap } from "../types/envVar";

const developmentEnvVars: PartialEnvVarMap = {
  idApiUrl:
    process.env.REACT_APP_USE_LOCAL_API_SERVER === "true"
      ? "http://localhost:3000"
      : "https://identity-management.nonprod.vibe.justworks.com",
};

export default developmentEnvVars;
